import React, { useMemo, useState } from "react";
import { FiX, FiCheck } from "react-icons/fi";
import { BLOCOS_MANUAIS, TRIBUTO_NOME } from "../mockDataSemanal";
import { parseNum } from "../utils/formatters";

/**
 * Modal "Adicionar parâmetro" — a pessoa escolhe o bloco da planilha
 * (Saldo credor, Notas Petrobras, Baixa de estoque, NF areia, Carta de
 * não aproveitamento) e digita o valor de cada tributo do bloco, como
 * nas linhas de input do protótipo HTML. Cada tributo com valor vira um
 * lançamento na tabela de manuais da semana e entra no cálculo.
 */
export default function LancamentoManualModal({ isOpen, onClose, onAdd, semanaNome }) {
  const [blocoId, setBlocoId] = useState(BLOCOS_MANUAIS[0].id);
  const [valores, setValores] = useState({}); // {tributo: "1.234,56"}

  const bloco = useMemo(
    () => BLOCOS_MANUAIS.find((b) => b.id === blocoId),
    [blocoId]
  );

  if (!isOpen) return null;

  const trocarBloco = (id) => {
    setBlocoId(id);
    setValores({});
  };

  const valorDe = (t) => parseNum(valores[t] || "");
  const algumValor = bloco.campos.some((c) => valorDe(c[0]) > 0);

  const confirmar = () => {
    bloco.campos.forEach((c) => {
      const v = valorDe(c[0]);
      if (v > 0) {
        onAdd({
          id: Date.now() + Math.random(),
          blocoId,
          tributo: c[0],
          valor: v,
          efeito: c[3],
        });
      }
    });
    setValores({});
    onClose();
  };

  return (
    <div className="lanc-modal-overlay" onClick={onClose}>
      <div className="lanc-modal param-modal" onClick={(e) => e.stopPropagation()}>
        <div className="lanc-modal-head">
          <h3>Adicionar parâmetro{semanaNome ? ` · ${semanaNome}` : ""}</h3>
          <button type="button" className="close" onClick={onClose}><FiX /></button>
        </div>

        <div className="lanc-modal-body">
          <span className="pick-label">Tipo de lançamento (bloco da planilha)</span>
          <div className="pick-list">
            {BLOCOS_MANUAIS.map((b) => (
              <button
                key={b.id}
                type="button"
                className={`pick-row ${b.id === blocoId ? "sel" : ""}`}
                onClick={() => trocarBloco(b.id)}
              >
                <span className="pr-title">{b.titulo}</span>
                {b.id === blocoId && <FiCheck className="pr-check" />}
              </button>
            ))}
          </div>
          <p className="lanc-note">{bloco.nota}</p>

          <span className="pick-label">Valores por tributo</span>
          <div className="mfield-list">
            {bloco.campos.map((c) => (
              <label className="mfield-row" key={c[0]}>
                <span className="mf-lab">
                  {TRIBUTO_NOME[c[0]]}
                  <small>{c[3]}</small>
                </span>
                <span className="valor-field mini">
                  <input
                    type="text"
                    inputMode="decimal"
                    placeholder="0,00"
                    value={valores[c[0]] || ""}
                    onChange={(e) =>
                      setValores((prev) => ({ ...prev, [c[0]]: e.target.value }))
                    }
                  />
                </span>
              </label>
            ))}
          </div>
        </div>

        <div className="lanc-modal-foot">
          <button type="button" className="btn-ghost" onClick={onClose}>Cancelar</button>
          <button type="button" className="btn-primary" onClick={confirmar} disabled={!algumValor}>
            <FiCheck /> Adicionar
          </button>
        </div>
      </div>
    </div>
  );
}
